// extracted by mini-css-extract-plugin
module.exports = {"link":"Footer_link__gh2xK"};